import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';

import './SubmitPopup.sass';

export const SubmitPopup = ({
  response,
  popupOpen,
  setPopupOpen,
  redirectLinkOnSuccessOrCancel,
  redirectFullOnSuccessOrCancel,
  onErrorRetry,
  loading,
  type,
  redirectCancelButtonText,
}) => {
  const errorContent = () => (
    <div className="error-popup">
      <div>
        Ihr Antrag konnte nicht gesendet werden. Bitte versuchen Sie es erneut. Falls der Fehler
        weiterhin auftritt, versuchen Sie es bitte später erneut.
      </div>
    </div>
  );

  const successContent = () => {
    if (type === 'DELETE_COMPANY') {
      return (
        <div className="success-popup">
          <div>Sie haben die Löschung Ihrer Eintragung beantragt.</div>
          <div>Die Löschung wird zeitnah im Installateurverzeichnis durchgeführt.</div>
        </div>
      );
    }

    if (type === 'EDIT_COMPANY') {
      return (
        <div className="success-popup">
          <div>Wir werden Ihren Antrag prüfen und Ihre Änderungen vornehmen.</div>
          <div>
            Falls wir Rückfragen haben, werden wir Sie in der Regel per E-Mail kontaktieren und bei
            Bedarf Dokumente nachfordern.
          </div>
          <div>Die Bearbeitung wird einige Zeit in Anspruch nehmen.</div>
        </div>
      );
    }

    if (type === 'NEW_ENTRY') {
      return (
        <div className="success-popup">
          <div>Wir werden Ihren Antrag prüfen.</div>
          <div>
            Falls wir Rückfragen haben, werden wir Sie in der Regel per E-Mail kontaktieren und bei
            Bedarf Dokumente nachfordern.
          </div>
          <div>Die Bearbeitung wird einige Zeit in Anspruch nehmen.</div>
        </div>
      );
    }

    return null;
  };

  const getTitle = () => {
    if (loading) {
      return '';
    }

    if (response === 'SUCCESS') {
      return 'Antrag erfolgreich gesendet!';
    }

    return 'Antrag senden fehlgeschlagen!';
  };

  const getContent = () => {
    if (loading) {
      return <LoadingIndicator />;
    }

    if (response === 'SUCCESS') {
      return successContent();
    }

    return errorContent();
  };

  if (response) {
    return (
      <CustomModal
        isOpen={popupOpen}
        title={getTitle()}
        ctaButtons={
          response === 'SUCCESS' ? (
            <ActionButton
              link={redirectLinkOnSuccessOrCancel}
              onClick={() => {
                if (redirectFullOnSuccessOrCancel) {
                  window.location.href = redirectFullOnSuccessOrCancel;
                }
                setPopupOpen(false);
              }}
              title="Ok"
            />
          ) : (
            <>
              <ActionButton
                link={redirectLinkOnSuccessOrCancel}
                onClick={() => {
                  if (redirectFullOnSuccessOrCancel) {
                    window.location.href = redirectFullOnSuccessOrCancel;
                  }
                  setPopupOpen(false);
                }}
                inverted
                title={redirectCancelButtonText}
              />
              <ActionButton
                onClick={() => {
                  onErrorRetry();
                }}
                title="Erneut senden"
              />
            </>
          )
        }
        content={getContent()}
      />
    );
  }
  return null;
};
SubmitPopup.propTypes = {
  response: PropTypes.string,
  popupOpen: PropTypes.bool,
  setPopupOpen: PropTypes.func,
  onErrorRetry: PropTypes.func,
  redirectLinkOnSuccessOrCancel: PropTypes.string,
  redirectFullOnSuccessOrCancel: PropTypes.string,
  redirectCancelButtonText: PropTypes.string,
  loading: PropTypes.bool,
  type: PropTypes.string,
};

SubmitPopup.defaultProps = {
  type: 'EDIT_COMPANY',
  redirectCancelButtonText: 'Abbrechen',
  loading: false,
  response: null,
  popupOpen: false,
  setPopupOpen: () => {},
  onErrorRetry: () => {},
  redirectLinkOnSuccessOrCancel: null,
  redirectFullOnSuccessOrCancel: null,
};
